import { render, staticRenderFns } from "./cityList.vue?vue&type=template&id=38919554&"
import script from "./cityList.vue?vue&type=script&lang=js&"
export * from "./cityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports